import { Info } from '@liveauctioneers/hammer-ui-core/icons';
import { FormattedNumber } from '@liveauctioneers/hammer-ui-core/intl';
import { Radio } from '@liveauctioneers/hammer-ui-core/radio';
import { BodySecondary, LabelStrong } from '@liveauctioneers/hammer-ui-core/text';
import { useCallback } from 'react';

import { useAppDispatch } from '@/redux/hooks';
import { openZipModal } from '@/redux/modules/modal';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

type Props = {
    active: boolean;
    amountToPayZip: number;
    currency: string;
    isSelected: boolean;
};

export const PaymentMethodZipPlan = ({ active, amountToPayZip, currency, isSelected }: Props) => {
    const formatMessage = useAppFormatMessage();
    const dispatch = useAppDispatch();

    const onZipInfoClick = useCallback(() => {
        dispatch(openZipModal());
    }, [dispatch]);

    const display = (
        <div>
            <div className="mb-2xs">
                <LabelStrong>
                    {formatMessage(['checkout', 'payment', 'zipPaymentsPlan'], {
                        values: {
                            amount: (
                                <FormattedNumber
                                    currency={currency}
                                    key="checkout-payment-zip-payments-plan-amount"
                                    style="currency"
                                    value={amountToPayZip}
                                />
                            ),
                        },
                    })}
                </LabelStrong>
                <img
                    alt="ZIP Logo"
                    className="mx-2xs my-0 w-[40px]"
                    src="https://p1.liveauctioneers.com/dist/images/zip-logo.svg"
                />
                <Info
                    className="inline-flex"
                    data-testid={formatMessage(['checkout', 'general', 'learnMore'])}
                    onClick={onZipInfoClick}
                    size="xs"
                />
            </div>
            <BodySecondary color="secondary">{formatMessage(['checkout', 'payment', 'zipInfo'])}</BodySecondary>
        </div>
    );

    if (!isSelected) {
        return null;
    }

    if (!active) {
        return display;
    }

    return (
        <div className="flex gap-xs">
            {/*
             * This is always selected because it's the only ZIP plan
             * By selecting the option (compared to credit card/ach),
             * the user has already made their plan selection.
             */}
            <Radio.Option
                id="zip"
                selected
            />
            <div>{display}</div>
        </div>
    );
};
